import getQueryFromSearchParams from './getQueryFromSearchParams';
import { Query } from '../types';
import { getCurrentSearchParams, GetterOptions } from './getCurrentSearchParams';

const prepareQuery = (query: Query, getterOptions: GetterOptions) => {
  const searchParams = getCurrentSearchParams(query, getterOptions);

  return getQueryFromSearchParams(searchParams);
};

export default prepareQuery;
